import React from 'react'
import { usePodcastEditor } from '../../context/use-podcast-editor'
import { Input } from '../../../../components/ui/input'

export const TitleForm: React.FC = () => {
  const { titleDraft, setTitleDraft, cancelEditTitle } = usePodcastEditor()
  return (
    <form
      className="inline-flex items-center gap-2"
      onSubmit={(e) => { e.preventDefault(); cancelEditTitle() }}
    >
      <Input
        autoFocus
        value={titleDraft}
        onChange={(e) => setTitleDraft(e.target.value)}
        onBlur={() => { cancelEditTitle() }}
        onKeyDown={(e) => { if (e.key === 'Escape') { cancelEditTitle() } }}
        size="sm"
        className="text-sm"
      />
    </form>
  )
}
